import { Time } from "@angular/common";
import moment from "moment";

export class TogglUserDetails {
    id: number;
    api_token: string;
    email: string;
    fullname: string;
    timezone: string;
    toggl_accounts_id: string;
    default_workspace_id: number;
    beginning_of_week: number;
    image_url: string;
    created_at: string;
    updated_at: string;
    openid_email: string | null;
    openid_enabled: boolean;
    country_id: string | null;
    has_password: boolean;
    at: string;
    intercom_hash: string;
    authorization_updated_at: string;
}

export class TogglLoginResult {
    success: boolean;
    error: string;
    user: TogglUserDetails;
}

export class TogglUserMatch {
    userId: string;
    userName: string;
    firstName: string;
    surname: string;
    togglUserId: number | null;
}
export class MatchTogglUsersResult {
    success: true;
    error: null;
    users: TogglUserMatch[];
}

export class MatchedTogglJobCounts {
    total: number;
    matched: number;
    unmatched: number;
    unmatchedJobs: UnmatchedJob[];
    matchedJobs: UnmatchedJob[];
}

export class UnmatchedJob {
    jobId: number;
    jobNumber: number;
    jobTitle: string;
    clientName: string;
}

export class LoadTimeEntriesResult {
    success: boolean;
    error: string;
    seconds: number;
    start: Date;
    end: Date;
}

export class UpdateTimeEntryRatesResult {
    success: boolean;
    error: string;
    seconds: number;
    start: Date;
    end: Date;
    oldValue: number;
    newValue: number;
}

export class TimeCalendarResult {
    success: boolean;
    error: string;
    calendar: TimeCalendar;
}

export class TimeCalendar {
    year: number;
    dayCounts: TogglDayCount[];
}

export class TogglDayCount {
    day: Date;
    count: number;
    seconds: number;
    value: number;
}

export class TogglTimerResult {
    success: boolean;
    error: string;
    runningJob: TogglRunningJob | null;
}

export class RecentTimerDescriptionsResult {
    success: boolean;
    error: string;
    descriptions: string[];
}

export class TogglRunningJob {
    jobId: number;
    jobTitle: string;
    jobNumber: number;
    clientName: string;
    startTime: moment.Moment;
    isRunning: boolean;
    description: string;
}

export interface RecentTimerEvent {
    jobId: number;
    jobNumber: string;
    jobTitle: string;
    clientName: string;
    description: string;
}